import { render, staticRenderFns } from "./ManagementConsolidations.vue?vue&type=template&id=5939944a&scoped=true&"
import script from "./ManagementConsolidations.vue?vue&type=script&lang=js&"
export * from "./ManagementConsolidations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5939944a",
  null
  
)

export default component.exports